<div #pdfContainer class="dev-document-viewer-pdf">
	<div style="align-self: center">
		<canvas #pdfCanvas style="display: block"></canvas>
	</div>
</div>
